import React from "react";
// import { Link } from "react-router-dom";
import SEO from "../seo/Seo";
import { Link } from "react-router";
import Chesapeak from "../media/Chesapeake.webp";
import ServicesContactForm from "../components/ServicesContactForm";

/**
 * Services.jsx
 * Página "Services" para Innovative Land Developers
 * Basada en el PDF y en la lista de servicios proporcionada.
 *
 * Requisitos: TailwindCSS (puedes adaptar las clases si usas CSS Modules).
 */

/* --- Icon components (SVGs inline para evitar dependencias) --- */
const IconSite = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="icon icon-tabler icons-tabler-outline icon-tabler-brand-netbeans"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033" />
    <path d="M15.5 9.43a1 1 0 0 1 .5 .874v3.268a1 1 0 0 1 -.515 .874l-3 1.917a1 1 0 0 1 -.97 0l-3 -1.917a1 1 0 0 1 -.515 -.873v-3.269a1 1 0 0 1 .514 -.874l3 -1.786c.311 -.173 .69 -.173 1 0l3 1.787h-.014l0 -.001" />
    <path d="M12 21v-9l-7.5 -4.5" />
    <path d="M12 12l7.5 -4.5" />
    <path d="M12 3v4.5" />
    <path d="M19.5 16l-3.5 -2" />
    <path d="M8 14l-3.5 2" />
  </svg>
);

const IconStorm = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-cloud-storm"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1" /><path d="M13 14l-2 4l3 0l-2 4" /></svg>
);

const IconGrading = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="icon icon-tabler icons-tabler-filled icon-tabler-file-analytics"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-3 10a1 1 0 0 0 -1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0 -1 -1m3 4a1 1 0 0 0 -1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0 -1 -1m3 -2a1 1 0 0 0 -1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0 -1 -1" /><path d="M19 7h-4l-.001 -4.001z" /></svg>);

const IconSurvey = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-vector"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" /><path d="M17 4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" /><path d="M17 18a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" /><path d="M3 18a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -2" /><path d="M5 7l0 10" /><path d="M19 7l0 10" /><path d="M7 5l10 0" /><path d="M7 19l10 0" /></svg>);

const iconMap = {
  "icon-site": <IconSite />,
  "icon-storm" : <IconStorm/>,
  "icon-grading" : <IconGrading/>,
  "icon-Survey" : <IconSurvey/>
};
/* --- Reusable Service Card --- */
function ServiceCard({ title, subtitle, bullets, icon }) {
  return (
    <article
      className="bg-blue-50 rounded-lg shadow-md p-6 flex flex-col h-full transition-transform hover:translate-y-[-4px] focus-within:translate-y-[-4px] text-primario"
      tabIndex={0}
      aria-labelledby={title.replace(/\s+/g, "-").toLowerCase()}
    >
      <div className="flex items-center gap-4 mb-4">
        <div className="bg-secundario text-primario rounded-md p-2">
          {iconMap[icon]}
        </div>
        <div>
          <h3
            id={title.replace(/\s+/g, "-").toLowerCase()}
            className="text-2xl lg:text-3xl font-semibold"
          >
            {title}
          </h3>
          {subtitle && <p className="lg:text-xl text-gray-500">{subtitle}</p>}
        </div>
      </div>

      <ul className="mt-2 mb-4 space-y-2 text-sm flex-1">
        {bullets.map((b, i) => (
          <li
            key={i}
            className="flex gap-3 items-center lg:text-xl text-gray-800"
          >
            <svg
              className="w-4 h-4 text-primario  shrink-0"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden
            >
              <circle cx="10" cy="10" r="10" />
            </svg>
            <span>{b}</span>
          </li>
        ))}
      </ul>
    </article>
  );
}

/* --- Services data (baseado en el PDF + datos extras enviados) --- */
const SERVICES = [
  {
    id: "site-development",
    title: "Site Development",
    subtitle:
      "Strategic civil engineering support for residential and commercial projects",
    icon: "icon-site",
    bullets: [
      "Site Plans for Commercial projects",
      "Erosion control & stabilization",
      "Residential lot grading plans",
      "Utility design (water, sewer, electric, gas)",
      "Subdivision Plans & Rezoning ",
      "Permit submission assistance",
    ],
  },
  {
    id: "stormwater-management",
    title: "Stormwater Management",
    subtitle:
      "Expert drainage and conveyance planning to protect site and environment",
    icon: "icon-storm",
    bullets: [
      "Storm sewer design & rehabilitation",
      "Drainage studies & watershed plans",
      "Runoff control for new developments",
      "Outfall mapping & inspections",
    ],
  },
  {
    id: "grading-feasibility",
    title: "Feasibility & Environmental",
    subtitle: "Feasibility studies and grading plans with code compliance",
    icon: "icon-grading",
    bullets: [
      "Feasibility studies for development",
      "Wetlands mapping & permitting",
      "Floodplain feasibility analysis",
    ],
  },
  {
    id: "surveying-services",
    title: "Surveying Services",
    subtitle: "Topographic, boundary, stake-out and house location surveys",
    icon: "icon-Survey",
    bullets: [
      "Topographic Surveys",
      "House Location Surveys – structure and boundary mapping",
      "Construction Stake-Out services",
      "Boundary Surveys – resolving lines and ownership limits",
    ],
  },
];

/* --- Main Page Component --- */
export default function Services() {
  return (
    <>
      <SEO
        title="Civil Engineering & Land Development Services"
        description="Innovative Land Developers — Site Development, Stormwater Management, Grading & Feasibility, Surveying Services across the DMV and the Virginia coast."
        keywords="Site development, stormwater management, grading, surveying, Northern Virginia, DMV, Virginia coast, land development"
        image="https://innovativeld.com/assets/Logo-InnovativeLD.png"
        url="https://www.innovativeld.com/services"
      />

      {/* HERO */}
      <section className="relative min-h-[80vh] bg-primario md:py-20 md:px-6 lg:px-16 font-secundaria text-start overflow-hidden">
        <img
          src={Chesapeak}
          alt="Civil Engineering & Land Development"
          className="absolute inset-0 w-full h-full object-cover opacity-60 blur-sm"
        />
        <div className="absolute inset-0 p-10 max-w-6xl mx-auto flex flex-col justify-center">
          <h1 className="text-5xl lg:text-8xl font-bold leading-tight mb-4 font-primaria text-secundario">
            Civil Engineering & Land Development
          </h1>
          <p className="text-lg lg:text-3xl  max-w-3xl mb-6 text-white">
            We provide disciplined, systems-based land development services
            across the DMV and the Virginia coast, from site planning and
            permitting to stormwater design and surveying.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 font-primaria ">
            <Link
              to="/consultation"
              className="inline-block bg-secundario text-primario font-semibold px-5 py-3 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-200"
              aria-label="Book a free consultation"
            >
              Book a Free Consultation
            </Link>

            <a
              href="mailto:info@innovativeld.com"
              className="inline-block bg-primario shadow-sm text-secundario px-5 py-3 rounded-full  focus:outline-none focus:ring-2 focus:ring-secundario/20"
            >
              Contact: info@innovativeld.com
            </a>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <main className="py-12 px-6 lg:px-16 bg-primario text-secundario font-secundaria">
        <div className="max-w-6xl mx-auto ">
          <section aria-labelledby="services-heading" className="mb-12 ">
            <h2
              id="services-heading"
              className="text-4xl lg:text-7xl font-semibold mb-4 font-primaria text-secundario"
            >
              Core Services
            </h2>
            <p className="text-gray-100  mb-6 text-lg lg:text-3xl">
              Below are our core service lines delivered by our experienced
              team. Each discipline is coordinated to minimize rework and
              shorten approval cycles.
            </p>

            <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
              {SERVICES.map((s) => (
                <ServiceCard
                  key={s.id}
                  title={s.title}
                  subtitle={s.subtitle}
                  bullets={s.bullets}
                  icon={s.icon}
                />
              ))}
            </div>
          </section>

          {/* Service Details / Approach */}
          <section aria-labelledby="approach-heading" className="mb-12">
            <h3
              id="approach-heading"
              className="text-4xl lg:text-6xl font-semibold mb-4 font-primaria"
            >
              How we deliver our services
            </h3>
            <div className="grid gap-8 md:grid-cols-2 text-lg lg:text-xl text-white">
              <div className="prose max-w-none">
                <p className="mb-4">
                  We align architects, engineers, local authorities and
                  developers from day one. We track the critical path, control
                  quality, and proactively manage resubmittals to avoid rework
                  and reduce idle time.
                </p>

                <ul>
                  <li>
                    <strong className="text-secundario">
                      Coordination & Communication:
                    </strong>{" "}
                    Centralized project updates and clear escalation paths keep
                    approvals moving.
                  </li>
                  <li>
                    <strong className="text-secundario">
                      Regulatory Familiarity:
                    </strong>{" "}
                    Deep knowledge of DMV jurisdictions and the Virginia coast
                    allows us to streamline permitting.
                  </li>
                  <li>
                    <strong className="text-secundario">
                      Quality Control:
                    </strong>{" "}
                    Internal checks reduce comments and accelerate final
                    approvals.
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg self-center">
                <h4 className="font-semibold mb-3 text-primario text-3xl">
                  Entitlement Risk Scan
                </h4>
                <p className="text-gray-700 mb-4 text-lg lg:text-xl">
                  Quick, high-level review of your project's entitlement path to
                  flag approval or cost risks before they escalate. Ideal as a
                  first step to any new project.
                </p>
                <Link
                  to="/entitlement"
                  className="inline-block px-4 py-2 text-xl text-center bg-primario text-white rounded-md font-semibold focus:outline-none focus:ring-2 focus:ring-blue-300"
                  aria-label="Request Entitlement Risk Scan"
                >
                  Request an Entitlement Risk Scan
                </Link>
              </div>
            </div>
          </section>

          {/* Regional Focus */}
          <section
            aria-labelledby="regional-heading"
            className="mb-12 text-lg lg:text-xl"
          >
            <h3
              id="regional-heading"
              className="text-4xl lg:text-6xl font-semibold mb-4 font-primaria"
            >
              Regional Coverage
            </h3>
            <p className="text-white mb-4">
              We operate across the{" "}
              <strong className="text-secundario">
                DMV (District-Maryland-Virginia)
              </strong>{" "}
              and the coastal regions of Virginia. Our team has experience
              navigating local authority requirements and environmental
              constraints specific to these jurisdictions.
            </p>
            <ul className="list-disc list-inside text-white">
              <li>
                Local permitting relationships throughout Northern Virginia
              </li>
              <li>
                Experience with wetlands and coastal permitting requirements
              </li>
              <li>
                Designs aligned with regional stormwater and environmental
                regulations
              </li>
            </ul>
          </section>
          <ServicesContactForm />
        </div>
      </main>
    </>
  );
}
